const $ = jQuery.noConflict();

export default class TripsByCategory {
    constructor() {
        this.block = $('.top-ten-trips-by-category');
        this.trigger = this.block.find('.single-filter');
        this.articlesWrapper = this.block.find('.tiles-grid');
        this.category = this.block.data('category');
    }

    init() {
        this.trigger.on('click', (e) => {
            e.preventDefault();
            this.trigger.removeClass('active');
            const that = $(e.delegateTarget);
            that.addClass('active');
            const term = that.data('term');
            const taxonomy = that.data('taxonomy');
            this.ajax(taxonomy, term);
        });
    }

    ajax(taxonomy, term) {
        $.ajax({
            method: 'POST',
            url: `${WP.apiUrl}trips-by-cat/`,
            data: {
                taxonomy,
                term,
                category: this.category,
            },
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', WP.apiNonce);
            },
            success: (response) => {
                this.articlesWrapper.html(response.content);
            },
            fail: (response) => {
                console.log('fail', response);
            }
        });
    }
}
